// extracted by mini-css-extract-plugin
export default {"wrapper":"InstructionStep_wrapper__KC7zV","label":"InstructionStep_label__ULoK3","title":"InstructionStep_title__bf+x-","instruction":"InstructionStep_instruction__AOHpl"};